import { useEffect, useRef, useState } from "react";
import Layout from "../../components/Layout";
import Link from "next/link";
import useSWR from "swr";
import Head from "next/head";
import api from "../../services/api";
import { useAuth } from "../../hooks/useAuth";

import MediaSections from "../../components/MediaSections";
import { useRouter } from "next/router";

export default function FindCategory({ initialData }) {
  const router = useRouter();
  const { apiLoaded, singleOrganization } = useAuth();
  const {
    data,
    mutate,
    error
  } = useSWR(
    `watch/discovery?group=${router.query.key}`,
    k => api.get(k).then(r => r.data),
    { initialData }
  );
  useEffect(() => {
    if (apiLoaded) mutate(initialData, false);
  }, [apiLoaded]);

  if (!data) {
    return <Layout loader landing />;
  }

  return (
    <Layout landing={true}>
      <Head>
        <title>{data.title} | Eventive</title>
      </Head>
      <div className="mt-8 sm:mt-10">
        <div className="text-center mb-1 sm:mb-2">
          <span className="bg-gray-600 text-gray-200 text-xs sm:text-base font-medium px-2 py-1 rounded-md">
            Now Showing on Eventive
          </span>
        </div>
        <h1 className="text-xl sm:text-3xl text-center font-bold leading-7 text-white sm:leading-9 mb-2 sm:mb-4">
          {data.title || "Unknown category"}
        </h1>
        <MediaSections
          sections={[
            {
              key: "data",
              items: data.items,
              display_mode: "default_grid"
            }
          ]}
          isDiscoveryList
        />
      </div>
    </Layout>
  );
}

export async function getServerSideProps({ query, res, locale }) {
  if (res) {
    res.setHeader("Cache-Control", "s-maxage=1, stale-while-revalidate");
  }

  let props;
  try {
    const data = await api
      .get(`watch/discovery?group=${query.key}`)
      .then(r => r.data);
    props = { initialData: data };
  } catch (e) {
    props = {};
  }

  return { props: { ...props } };
}
